import { gql } from '@apollo/client';

export const GET_ACTION_BUDGET_ITEMS_HISTORICAL = gql`
  query GetActionBudgetItemsHistorical($input: FilterActionBudgetItemList!) {
    actionBudgetItemsHistorical(input: $input) {
      actionBudgetItems {
        id
        quantity
        totalAmount
        createdAt
        state
        budgetItem {
          id
          code
          description
          unit
          unitPrice
          budgetCategory {
            code
            name
            color
          }
        }
        action {
          id
          indexExpedition
          indexType
          registerInitDate
          roid
          actionTitle
          pkInitKm
          pkInitMeter
          pkEndKm
          pkEndMeter
          concessions {
            id
            name
          }
          externalCompanies
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const GET_ACTION_BUDGET_ITEM_BY_ID = gql`
  query GetActionBudgetItemById($id: ID!) {
    actionBudgetItem(id: $id) {
      id
      quantity
      totalAmount
      createdAt
      budgetItem {
        id
        code
        description
        unit
        unitPrice
        budgetCategory {
          code
          name
          color
        }
      }
      action {
        id
        indexExpedition
        indexType
        registerInitDate
        roid
        actionTitle
        pkInitKm
        pkInitMeter
        pkEndKm
        pkEndMeter
        concessions {
          id
          name
        }
        externalCompanies
      }
    }
  }
`;
